module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ChFront",
    attrs: {
      "id": "frontmatter01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("I would like to acknowledge")]), _vm._v(" co-author Shane Gibson of Vancouver, Canada, for ushering me into the world of Social Media with his landmark book, “Guerrilla Social Media Marketing.” I also wish to acknowledge Kelvin Lim, for traveling halfway around the world to be a better guerrilla marketer, then giving wings to his potential with words and deeds.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('strong', [_vm._v("—Jay Conrad Levinson")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Every project involves the")]), _vm._v(" contributions of many “invisible” individuals, and this book project is no different. There are many people whom I am indebted to, and want to acknowledge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My first thanks go out to Jay and Jeannie Levinson. It is a dream come true for me to work on a project with Jay together, an aspiration I’ve had since I was a college student. Jay, thank you for the opportunity to advance Guerrilla Marketing into print with me. You are my hero and an inspiration to everyone out there. Jeannie, thank you for being the most wonderful support and encouraging President of Guerrilla Marketing International for this project.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v("My thanks go out to my dearest friend Paul Ang, whose ideas and work match that of any true Guerrilla.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my editor and partner-in-crime, Su-Ann Mae Phillips, it was fun spending all those hours ironing out this project. I look forward to many more opportunities with you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my team at Guerrilla Marketing Consulting:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I want to acknowledge Andre Lee and Stuart Tan, true guerrilla partners and directors of Guerrilla Marketing Consulting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eu Simin, for being a power-packed and most capable campaign manager that I know of.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my team at Executive Coach International:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you for your tireless support over the years. You have given me the space and resources I needed to work on amazing projects down various paths I have taken. I acknowledge all of you for your boldness and courage to live your lives to the fullest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my buddy Jimmy Wong, thanks for your friendship and partnership; may we have more exciting projects to work on together. You are one fine Guerrilla.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally and most of all, to my dad and mom. Dad, don’t ever stop surprising me with your willingness and capability to move with the times. Mom, you are my inspiration and my reason. I love you both.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('strong', [_vm._v("—Kelvin Lim")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335a713d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 75
// module chunks = 0